export function authenticateFinished() {
  const authenticateFinishedFunctionName = window.testConfig?.authenticateFinishedFunctionName
  if (authenticateFinishedFunctionName) {
    window[authenticateFinishedFunctionName]?.()
  }
}
